<template>
<div class="section_b_">
    <ul class="tabs_">
        <li v-for="(item, index) in tabs" @click="handleTabChange(index)"
            :class="tabType == index ? 'active_' : ''" 
            class="item_">{{item}}</li>
    </ul>
    <div v-if="tabType == 0" class="content_">
*The maximum insured age is 64 years old; the maximum renewal age is 99 years old.
*最高入保年龄为64岁, 续保年龄至99岁。
*The spouse or child of the main insured (child must under age 21; Fill-time student must be under age 26) can be regarded as the additional insured of this contract. Child aged from 0 to 17 only can be regarded as additional insured
*主被保险人的配偶或子女（投保时应未满21岁;为全日制在校学生的，年龄应未满26岁）可作为本合同附属被保险人；0-17岁子女只能以附属被保险人身份入保。
*During the whole policy year,the main insured and additional insured must live in mainland China for at least 2/3(eight months)
*整个保险年度内，主被保险人以及附属被保险人必须居住在中国大陆至少达2/3以上的时间(8个月)。
*Medical examination report of nearly three months is required for the new insured aged 60 and above, whether to meet the insurance requirements and underwriting terms are subject to medical underwriting review. If the insurance is confirmed by underwriting, the insured age between 60-65 years old, additional 15% premium; the insured age between 66-70 years old, additional 30% premium.
*初次入保60岁及以上人员需提交近三个月的体检报告，经过核保后确认是否承保及具体的承保条件。若通过核保确认承保，入保年龄在60-65岁之间的被保险人，另加收15%保费；入保年龄在66-70岁之间的被保险人，加收30%保费。
* The final rate table will be decided and adjusted by the final census list provided. Over 20% changes in the final census compared with the census provided at quotation stage will result in a price change.
* 最终价格需根据实际的人员清单。最终投保人员数量与报价阶段提供的人员数量超过20%变动将导致价格变动。

Critical Illness Definition:
其中重大既往症是指：
(1) Cardiovascular diseases - including coronary heart disease, congenital heart disease, myocardial infarction, aortic aneurysm.
(1) 心血管疾病 - 包括冠心病、 先天性心脏病、 心肌梗塞、 主动脉瘤。
(2) Neurological diseases - including stroke, cerebral aneurysm, Alzheimer's disease, Parkinson's disease, syringomyelia, multiple sclerosis.
(2) 神经疾病 - 包括脑卒中、脑动脉瘤、阿尔茨海默病、帕金森病、脊髓空洞症、多发性硬化症。
(3) Blood diseases - including leukemia, lymphoma, aplastic anemia, thrombocytopenic purpura, hemophilia.
(3) 血液疾病－包括白血病、 淋巴瘤、 再生障碍性贫血、 血小板减少性紫癜、 血友病。
(4) Pulmonary diseases - chronic obstructive pulmonary disease, primary pulmonary hypertension.
(4) 肺部疾病－慢性阻塞性肺病、 原发性肺动脉高压。
(5) Digestive diseases - cirrhosis, severe hepatitis.
(5) 消化疾病－肝硬化、 重症肝炎。
(6) Autoimmune diseases - including systemic lupus erythematosus, systemic scleroderma，Acquired immunodeficiency syndrome (AIDS, AIDS), AIDS related syndrome (ARCS) and other HIV related sexually transmitted diseases or symptoms
(6) 自身免疫性疾病－包括系统性红斑狼疮、 系统性硬皮病，获得性免疫缺陷综合症（AIDS，艾滋病）、艾滋相关综合征（ARCS）和其他与 HIV 病毒相关的性传染病或者症状
(7) Others - including Malignant tumor, benign brain tumors, benign spinal cord tumor, major organ failure or transplant, cystic fibrosis, shading polyposis, Ⅲ degree burns.
(7) 其他 - 恶性肿瘤、良性脑肿瘤、良性脊髓肿瘤、主要器官衰竭或者移植、囊性纤维化、黑斑息肉病、Ⅲ度烧伤
							
Combination plan:
组合计划：
<div v-if="planValue=='1'">1、 One insurance plan for the group with 3 employees.
1、3名员工团体最多可投保一个计划保障方案。
2、One to two insurance plans for the group with 4 employees and above.
2、4名员工及以上的团体最多可投保两个计划保障方案。
3、The same plan for all members of a family.
3、同一家人需选择一样的计划。
4、Optional maternity care is only for group with 5 employees and above. If two or more insurance plans are included, the number of employees is required to be 5 or more than 5 for the insurance plan with maternity care selected. A 10-month waiting period is calculated from the date of the insured's first participation in the insurance, and the insurance shall be continuously insured; expenses are payable after waiting period. If the person is pregnant at the time of enrollment, the expenses related to the pregnancy and childbirth will not be covered.
4、生育责任自选开放给5名员工及以上的团体，若包含两个或以上保险计划，选择生育责任的保险计划要求员工人数超过5人（含）。等待期10个月，自被保险人首次参保开始计算，连续投保10个月后可按照保险责任进行赔付。带孕投保人员该次孕产相关费用不予以赔付。
5、The annual premium must be paid in lump sum.
5、年度人民币保费支付方式需一次付清。
6、This quotation is only for proposal purpose. Because of the change of company policies and business situation,this quotation cannot be reference for the next quotation.Please reacquire another quotation if there are any changes in insurance clause.
6、 本次报价仅针对此次业务情况，因公司政策可变且业务情况不同，本次报价不作为下次报价的参考依据。条件有变或方案有调整请重新询价。</div>
<div v-else>1、 One insurance plan for the group with 3 employees.
1、3名员工团体最多可投保一个计划保障方案。
2、One to two insurance plans for the group with 4-10 employees.	
2、4-10名员工的团体最多可投保两个计划保障方案。
3、One to three insurance plans for the group with more than 10 employees.	
3、超过10名员工的团体最多可投保三个计划保障方案。
4、The same plan for all members of a family.
4、同一家人需选择一样的计划	
5、The annual premium must be paid in lump sum.
5、年度人民币保费支付方式需一次付清。
6、This quotation is only for proposal purpose. Because of the change of company policies and business situation,this quotation cannot be reference for the next quotation.Please reacquire another quotation if there are any changes in insurance clause.
6、本次报价仅针对此次业务情况，因公司政策可变且业务情况不同，本次报价不作为下次报价的参考依据。条件有变或方案有调整请重新询价。</div>

Please read the insurance clause carefully before insuring. 
投保前请阅读条款和会员手册。

The above plan and quotation should be interpreted and understood together with the terms. The part not covered by the quotation subject to the insurance terms.
上述保障方案与报价，应与《团体条款》一起解读、理解，本报价未涉及部分，以保险条款为准。
    </div>
    <div class="content_" v-else-if="tabType == 1">
        <ul class="steps_wrap_">
            <li class="item_">
                <img class="img_" src="~@/assets/quote/2.png">
                <span class="line_h">1、提供投保信息</span><br>
                <!-- <span class="font_14">（60岁及以上人员投保需提交近三个月的体检报告）</span> -->
            </li>
            <li class="item_">
                <img src="~@/assets/quote/3.png" class="img_">
                <span class="line_h">2、提供人员清单</span><br>
                <!-- <span class="font_14">（最终价格需根据实际的人员清单；最终投保人员数量与报价阶段提供的人员数量超过20%变动将导致价格变动）</span> -->
            </li>
            <li class="item_">
                <img src="~@/assets/quote/2.png" class="img_">
                <span class="line_h">3、提交投保成功</span>
            </li>
            <li class="item_">
                <img src="~@/assets/quote/2.png" class="img_">
                <span class="line_h">4、支付保费</span>
            </li>
        </ul>
    </div>
    <div class="content_" v-else>
        <table class="table_" style="width: 100%;" border>
            <tr>
                <td>All the United Family Hospitals and clinics和睦家所有医院或诊所  ;</td>
            </tr>
            <tr>
                <td>Raffles Medical Beijing/Shenzhen/Tianjin/Tianjin Taida/Nanjing/Dalian Clinics (International SOS Clinics in Nanjing, Tianjin, Tianjin Taida,Shenzhen, Beijing and Dalian)莱佛士医疗北京/深圳/天津/天津泰达/南京/大连诊所（南京、天津、天津泰达、深圳国际（SOS）紧急救援诊所；北京国际（SOS）救援中心、大连安慎诊所） ;</td>
            </tr>
            <tr>
                <td>All the medical centers belong to Parkway Health Medical Centers in mainland China (except Hong Kong, Chengdu Gleneagle and all Shenton Health Clinics)百汇医疗集团旗下医疗机构（除香港和成都鹰阁外的其它城市；除百汇馨康品牌旗下的医疗机构）;</td>
            </tr>
            <tr>
                <td>Shanghai International Medical Center上海国际医学中心 </td>
            </tr>
            <tr>
                <td>All Global HealthCare Clinics上海全康医疗中心/上海众康门诊部 </td>
            </tr>
            <tr>
                <td>Shanghai East International Medical Center上海东方联合医院 </td>
            </tr>
            <tr>
                <td>Shanghai Redleaf International Women's & Children's Hospital上海红枫国际妇儿医院 </td>
            </tr>
            <tr>
                <td>All Adventist clinics and Medical Centers港安医院 </td>
            </tr>
            <tr>
                <td>Matilda Hospital香港明德医院 </td>
            </tr>
            <tr>
                <td>Sanatorium Hospital香港养和医院</td>
            </tr>
            <tr>
                <td>Mount Elizabeth Hospital(Singapore)伊丽莎白医院（新加坡） </td>
            </tr>
            <tr>
                <td>Mount Elizabeth Novena Hospital伊丽莎白诺维娜医院（新加坡） </td>
            </tr>
            <tr>
                <td>Gleneagles Hospital(Singapore)鹰阁医院（新加坡） </td>
            </tr>
        </table>
        <p style="font-weight:bold">Excluded Providers除外医疗机构 :</p>
        <p>(This Policy does not cover any medical treatment at the following medical institutions本保单在以下医疗机构内的任何就诊不予赔付)</p>
        <table class="table_" style="width: 100%;" border>
            <tr>
                <td>Huzhou Ruibo Tongyitang TCM Outpatient Department湖州瑞博同义堂中医门诊部 </td>   
            </tr>
            <tr><td>Beijing Tai-Tong Yitang北京太一同义堂 </td></tr>
            <tr><td>Bi Zaiwang (Chinese Medicine)毕再旺（中医）</td></tr>
            <tr><td>Asia Medical Specialists / Sportsphysicians Sportsperformance Ltd.亚洲专科医生/运动内科医生</td></tr>
        </table>
         <p style="font-weight:bold">Pre-Authorization 事先授权说明:</p>
         <p>All members must receive pre-authorization prior to undergoing certain procedures/treatments listed below. Pre-Authorization provides assurance they will be reimbursed for expenses incurred from pre-authorized medical treatment and confirms in advance that the procedure/treatment will be covered under their policy. If pre-authorization is not obtained before treatment, the insurance company has the right to decline the corresponding expenses incurred form the treatment. If the pre-authorization cannot be obtained due to emergency situations, members should inform MedilLink-Global Customer Service within 48 hours, to ensure that treatment will be covered under their insurance policy.在接受以下列表中任何一项治疗或医疗项目之前，会员都必须获得事先授权。若治疗之前未获得事先授权，保险公司有权不承担相应的治疗费用。遇紧急情况无法获得事先授权，会员只需在急诊48小时内通知中间带客服团队，确保不必因没有获得事先授权而无法获得赔付。</p>
         <table class="table_" style="width: 100%;" border>
            <tr>
                <td>Hospitalization- Pre-Authorization is required for all locations. (Incl. Hospital stay for Maternity / Delivery);所有住院治疗都需要事先授权（包括生育/分娩的住院）；</td>   
            </tr>
            <tr><td>Outpatient Surgeries requiring general anesthesia; Chemotherapy, radiation therapy, hemoperitoneal dialysis;任何需要全麻下进行的门诊手术；化学治疗，放射治疗，血液或腹膜透析;</td></tr>
            <tr><td>Purchase or rent disposable, durable medical equipment, including but not limited to insulin pumps and their associated equipment;购买或者使用非一次性耐用医疗设备，包括但不限于胰岛素泵及其配套器械；</td></tr>
            <tr><td>Emergency medical evacuation；紧急医疗转运；</td></tr>
            <tr><td>Dental accidental injury repair treatment；牙科意外伤害修补治疗</td></tr>
            <tr><td>A drug or vaccine that costs more than ￥8,000 per dose.每剂超过8,000元的药剂或疫苗。</td></tr>
        </table>
    </div>
</div>
</template>
<style lang="scss" scoped>
    .section_b_ {
        margin-top: 12px;
        border: 1px solid #eee;
        .table_ {
            width: 100%;
            table-layout: fixed;
            white-space: normal;
            border: 1px solid #eee;
            margin-bottom: 32px;
            td {
                padding: 6px;
            }
        }
        .steps_wrap_ {
            margin-left: 30px;
            padding-left: 60px;
            white-space: nowrap;
            border-left: 1px solid #6284fe;
            .item_ {
                position: relative;
                margin-bottom: 60px;
                color: #333;
                font-weight: bold;
                font-size: 18px;
                .line_h{
                    line-height: 68px;
                }
                .font_14{
                    font-size:14px;
                    font-weight:normal;
                    white-space: pre-line;
                    line-height:20px;
                }
            }
            .img_ {
                width: 68px;
                height: auto;
                position: absolute;
                left: -96px;
            }
        }
        .content_ {
            height: 600px;
            overflow-y: auto;
            white-space: pre-wrap;
            padding: 0 12px;
        }
        .tabs_ {
            display: flex;
            border-bottom: 1px solid #eee;
            line-height: 52px;
            text-align: center;
            .item_ {
                flex: 1;
                &.active_ {
                    border-bottom: 1px solid rgb(61, 94, 213);;
                }
            }
        }
        
    }
</style>
<script>
export default {
    props: {
        planValue: {
            type: String,
            default: '1'
        }
    },
    data () {
        return {
            tabs: ['投保须知', '投保流程', '昂贵医院列表'],
            tabType: 0
        }
    },
    methods: {
        handleTabChange(index) {
            this.tabType = index;
        }
    }
}
</script>